import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

interface Props {
  open: boolean;
  busy: boolean;
  endsMeeting: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
}

export default function VideoExitConfirmation({ open, busy, endsMeeting, onCancel, onConfirm }: Props) {
  return <Dialog open={open} onClose={busy ? undefined : onCancel} aria-labelledby="video-exit-title">
    <DialogTitle id="video-exit-title">{endsMeeting ? "結束視訊通話？" : "離開視訊通話？"}</DialogTitle>
    <DialogContent><DialogContentText>{endsMeeting ? "結束後，雙方都會離開此次視訊通話。" : "確定要離開此次視訊通話嗎？"}</DialogContentText></DialogContent>
    <DialogActions>
      <Button autoFocus disabled={busy} onClick={onCancel}>取消</Button>
      <Button color="error" disabled={busy} onClick={onConfirm}>{endsMeeting ? "確認結束" : "確認離開"}</Button>
    </DialogActions>
  </Dialog>;
}
